import { useState } from "react";

import { Alert, Button, Menu, MenuItem } from "@mui/material";

import { formatDate } from "@aclymatepackages/formatters";

import SmartUploadReviewDialog from "./SmartUploadReviewDialog";
import { REVIEWABLE_TASK_STATUSES } from "./reviewLineGates";

import {
  useAccountData,
  useCollectionDataListener
} from "../../../helpers/firebase";

const batchLabel = ({ created_at: createdAt, startTime }) => {
  const date = createdAt || startTime;
  return date ? `Uploaded ${formatDate(date)}` : "Uploaded batch";
};

const newestFirst = (batches) =>
  [...batches].sort(
    (first, second) =>
      new Date(second.created_at || second.startTime || 0) -
      new Date(first.created_at || first.startTime || 0)
  );

// "N Smart Upload batches ready to review" on the dashboard Activity view
// (Design Intent 3.6). A live listener, since batches reach ready_for_review
// from the backend's extraction step, not through a cached client write.
const SmartUploadReadyBanner = () => {
  const [{ id: companyId }] = useAccountData();
  const [readyBatches] = useCollectionDataListener("tasks", [
    ["type", "==", "smart-upload"],
    ["status", "in", REVIEWABLE_TASK_STATUSES]
  ]);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [reviewTaskId, setReviewTaskId] = useState(null);

  const batches = newestFirst(
    (readyBatches || []).filter(({ archived }) => !archived)
  );

  if (!batches.length && !reviewTaskId) {
    return null;
  }

  const count = batches.length;
  const openReview = (taskDocId) => {
    setMenuAnchor(null);
    return setReviewTaskId(taskDocId);
  };

  return (
    <>
      {!!count && (
        <Alert
          severity="info"
          sx={{ mb: 2 }}
          action={
            <Button
              size="small"
              onClick={(event) =>
                count === 1
                  ? openReview(batches[0].id)
                  : setMenuAnchor(event.currentTarget)
              }
            >
              Review
            </Button>
          }
        >
          {count} Smart Upload {count === 1 ? "batch" : "batches"} ready to
          review
        </Alert>
      )}
      <Menu
        anchorEl={menuAnchor}
        open={!!menuAnchor}
        onClose={() => setMenuAnchor(null)}
      >
        {batches.map((batch) => (
          <MenuItem key={batch.id} onClick={() => openReview(batch.id)}>
            {batchLabel(batch)}
          </MenuItem>
        ))}
      </Menu>
      {reviewTaskId && (
        <SmartUploadReviewDialog
          companyId={companyId}
          taskDocId={reviewTaskId}
          onClose={() => setReviewTaskId(null)}
        />
      )}
    </>
  );
};

export default SmartUploadReadyBanner;
